import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { promptDismissed, selectDismissedPrompts } from './promptsSlice';

/**
 * Whether a prompt has been closed during this page load, and a way to close it.
 *
 * <p>Lasts until the next refresh — see {@link promptsSlice} for why that boundary rather than
 * forever.
 *
 * @param key stable per prompt; two prompts sharing one would close together
 */
export function useDismissed(key: string): [boolean, () => void] {
  const dispatch = useAppDispatch();
  const dismissed = useAppSelector(selectDismissedPrompts).includes(key);

  const dismiss = useCallback(() => {
    dispatch(promptDismissed(key));
  }, [dispatch, key]);

  return [dismissed, dismiss];
}
